// Full-screen view of a task's report (design §7): `/tasks/$taskId/report`.
// Same panel as the task drawer's Report tab, with a taller frame and no
// submissions list.

import { Link, useParams } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { tasksApi } from '../lib/api-client'
import { PageHeader } from '../components/ui'
import { TaskReport } from '../components/reports/task-report'
import { TaskStatus } from '@goblic/shared'

const LIVE: readonly TaskStatus[] = [
  TaskStatus.Assigned,
  TaskStatus.InProgress,
  TaskStatus.AwaitingApproval,
]

export function TaskReportPage() {
  const { taskId } = useParams({ from: '/_authenticated/tasks/$taskId/report' })
  // Poll the task's status so `live` (and with it the report's polling for
  // new versions) follows the task: often while it runs, slowly otherwise
  // (a finished task can be picked up again).
  const taskQuery = useQuery({
    queryKey: ['task', taskId],
    queryFn: () => tasksApi.get(taskId),
    refetchInterval: (query) => {
      const status = query.state.data?.status
      return status && LIVE.includes(status) ? 10_000 : 60_000
    },
  })
  const task = taskQuery.data

  return (
    <div>
      <PageHeader
        title={task ? task.title : 'Report'}
        description="Report"
        back={
          <Link
            to="/tasks"
            search={{ taskId, tab: 'report' }}
            className="link"
          >
            ← Back to the task
          </Link>
        }
      />
      <div className="panel p-5">
        <TaskReport
          taskId={taskId}
          variant="fullscreen"
          live={task ? LIVE.includes(task.status) : false}
        />
      </div>
    </div>
  )
}
